export const leadFormStyles = () => ({
    autocomplete: {
        '& input': {
            paddingTop: '2.5px !important'
        }
    },
    container: {
        backgroundColor: 'white',
        padding: 20,
        borderRadius: 4
    },
    table: {
        width: 400
    },
    label: {
        minWidth: 150
    },
    box: {
        marginBottom: 30,
        '& label': {
            fontSize: 18
        }
    },
    textField: {
        width: 300
    },
    textFieldWide: {
        width: 453
    },
    textArea: {
        width: 453,
        minHeight: 200
    },
    textAreaForCode: {
        minHeight: 300
    },
    wysiwyg: {
        maxWidth: 600
    }
});
